export const CONTENT_MAX_WIDTH = 1180;

export const CONTENT_COLUMN_SX = {
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    mx: 'auto',
};
